
export const ROOT_URL = process.env.REACT_APP_ROOT_URL;

class App {
  /**
   * Get the current access token.
   * C4 FIX: No longer reads from localStorage - token is managed in-memory by AuthProvider.
   * For Authentik tokens, also checks localStorage for persistence across app restarts.
   */
  getAccessToken() {
    if (this.accessToken) return this.accessToken;
    // For Authentik tokens stored in localStorage (persists across app restarts)
    if (this.authProvider === 'authentik') {
        return localStorage.getItem('authentik_token');
    }
    // Fallback: check localStorage even if provider isn't set yet (race condition)
    return localStorage.getItem('authentik_token');
  }

  /**
   * Set an access token for the application.
   * C4 FIX: Token is stored in memory ONLY - never in localStorage.
   * For Authentik, also stores in localStorage (persists across app restarts for PWA/mobile).
   * 
   * @param {*} token
   */
  setAccessToken(token) {
    this.accessToken = token;
    // Store Authentik tokens in localStorage for persistence across app restarts
    // Always store in localStorage if provider is authentik, or if no provider is set yet
    // (handles race condition where setAccessToken is called before setAuthProvider)
    if (this.authProvider === 'authentik' || !this.authProvider) {
        localStorage.setItem('authentik_token', token);
    }
  }

  /**
   * Get the current auth provider (google or authentik).
   */
  getAuthProvider() {
    return this.authProvider || null;
  }

  /**
   * Set the auth provider.
   */
  setAuthProvider(provider) {
    this.authProvider = provider;
  }

  setSelectedShoppingList(id) {
    localStorage.setItem('selectedShoppingList', id);
  }

  getSelectedShoppingList() {
    return localStorage.getItem('selectedShoppingList')
  }

  setSelectedVault(id) {
    localStorage.setItem('selectedVault', id);
  }

  getSelectedVault() {
    return localStorage.getItem('selectedVault')
  }

  setSelectedRecipeBook(id) {
    localStorage.setItem('selectedRecipeBook', id);
  }

  getSelectedRecipeBook() {
    return localStorage.getItem('selectedRecipeBook')
  }

  /**
   * Remove the access token.
   */
  removeAccessToken() {
    this.accessToken = null;
  }

  /**
   * Get the data for the current user authenticated.
   * C4 FIX: No longer reads from localStorage - user data is managed in-memory by AuthProvider.
   */
  getAuthUserData() {
    return this.userData || null;
  }

  /**
   * Set the data for the current athenticated user.
   * C4 FIX: User data (including role) is stored in memory ONLY - never in localStorage.
   * Storing role in localStorage allows it to be tampered with via XSS.
   * 
   * @param data
   */
  setAuthUserData(data) {
    this.userData = data;
  }

  /**
   * Store the accessToken and the user data and configure the app 
   * for the correct use of the authenticated user.
   */
  configureAuthUser(result) {
    // Set the accessToken and configure it on axios configuration.
    this.setAccessToken(result.accessToken);
    this.setAuthUserData(result.data);
    window.axios.defaults.headers.common['accessToken'] = Application.getAccessToken();
  }

  /**
   * Clears all data associated with the user currently logged in.
   */
  logout() {
    this.removeAccessToken();
    this.userData = null;
    this.authProvider = null;
    sessionStorage.removeItem('acceptedBkUdfPopup');
    localStorage.removeItem('authentik_token');
    localStorage.removeItem('authentik_refresh_token');
  }


  /**
   * Show a generic message for a internal error without give details.
   */
  showInternalError() {
    // this.showErrorMessage(INTERNAL_ERROR);
  }
}

export let Application = new App();